import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, applyMiddleware } from 'redux'
import loginReducer from './reducers/LoginReducer'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import '../src/CSS/assets-minified/all-demo.css'
// import App from './App';
import { BrowserRouter as Router, Route } from 'react-router-dom'
import registerServiceWorker from './registerServiceWorker'

//Moved to ./Routes
import Splash from './Routes/Splash'
import Login from './Routes/Login'
import Dashboard from './Routes/Dashboard'
import ForgotPassword from './Routes/ForgotPassword'
import OrganizationView from './Routes/OrganizationView'
import CreateQuestionPageOne from './Routes/CreateQuestionP1'
import Questions from './Routes/Questions'
import CreateOrganization from './Routes/CreateOrganization'
import BranchView from './Routes/AllBranchesView'
import CreateBranch from './Routes/CreateBranch'
import ListBranches from './Routes/ListOrgBranches'
import CreateUser from './Routes/CreateUser'
import CreateBranchAdmin from './Routes/CreateBranchAdminUser'
import DeviceRegisterationRequests from './Routes/DeviceRegisterationsRequests'
import ViewAllDevices from './Routes/AllDevicesView'

import ListBranchDevices from './Routes/ListDevicesByBranch'
import ListBranchRevokedDevices from './Routes/ListBranchRevokedDevices'
import RevokedOrganizationList from './Routes/ListRevokedOrganizations'
import RevokedOrganizationViewPanel from './Routes/ListRevokedBranches'
import QuestionResponseList from './Routes/QuestionResponseList'
import RoleManagement from './Routes/RoleManagement'
import ResetPassword from './Routes/ResetPassword'
import AuthCallback from './Routes/AuthCallback'

// import NotFound from '../src/components/404NotFound';

//creating redux store
const store = createStore(loginReducer, applyMiddleware(thunk))

ReactDOM.render(
    <Router>
        <Provider store={store}>
            <div>
                <Route exact path="/" component={Splash} />
                <Route path="/login" component={Login} />
                <Route path="/dashboard" component={Dashboard} />
                <Route path="/forgotpassword" component={ForgotPassword} />
                <Route path="/view-organization" component={OrganizationView} />
                <Route
                    path="/create-question"
                    component={CreateQuestionPageOne}
                />
                <Route path="/questions" component={Questions} />
                <Route
                    path="/create-organization"
                    component={CreateOrganization}
                />
                <Route path="/view-all-branches" component={BranchView} />
                <Route path="/create-branch" component={CreateBranch} />
                <Route path="/list-branches/" component={ListBranches} />
                <Route path="/create-user/" component={CreateUser} />
                <Route
                    path="/create-branch-admin/"
                    component={CreateBranchAdmin}
                />
                <Route
                    path="/device-registeration-requests/"
                    component={DeviceRegisterationRequests}
                />
                <Route path="/view-all-devices/" component={ViewAllDevices} />
                <Route path="/list-devices/" component={ListBranchDevices} />
                <Route
                    path="/list-revoked-devices/"
                    component={ListBranchRevokedDevices}
                />
                <Route
                    path="/list-revoked-organizations/"
                    component={RevokedOrganizationList}
                />
                <Route
                    path="/list-revoked-branches/"
                    component={RevokedOrganizationViewPanel}
                />
                <Route
                    path="/response-listing/"
                    component={QuestionResponseList}
                />
                <Route path="/role-management/" component={RoleManagement} />
                <Route path="/reset-password/" component={ResetPassword} />
                <Route exact path="/callback" component={AuthCallback} />
                {/* <Route exact insecure component={NotFound}/> */}
            </div>
        </Provider>
    </Router>,
    document.getElementById('page-wrapper')
)

registerServiceWorker()



// WEBPACK FOOTER //
// src/index.js